<template>
  <div class="header-menu">
    <div class="header-content">
      <div class="logo-section">
        <router-link to="/" class="logo-link">
          <img
            class="logo-image"
            src="../assets/logo.png"
            alt="KLIMBUD Logo"
          />
        </router-link>
      </div>

      <div class="user-section">
        <router-link to="/usersettings" class="user-link">
          <div class="user-info" v-if="userProfile">
            <div class="user-text">
              <span class="user-name">{{ userProfile.name }}</span>
              <span class="user-settings">USTAWIENIA</span>
            </div>
            <div class="user-avatar">
              {{ userProfile.name.charAt(0).toUpperCase() }}
            </div>
          </div>
          <div class="user-loading blink" v-else>
            <svg
              width="20"
              height="20"
              viewBox="0 0 16 16"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M11.5 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM9.05 3a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0V3h9.05zM4.5 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM2.05 8a2.5 2.5 0 0 1 4.9 0H16v1H6.95a2.5 2.5 0 0 1-4.9 0H0V8h2.05zm9.45 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm-2.45 1a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0v-1h9.05z"
              />
            </svg>
          </div>
        </router-link>
        <p class="version-badge" @click="openVersionModal">v3.6</p>
      </div>
    </div>
    <version-modal></version-modal>
  </div>
</template>
<script>
import { mapState } from "vuex";
import VersionModal from "./VersionModal";
export default {
  components: {
    "version-modal": VersionModal,
  },
  computed: {
    ...mapState(["userProfile"]),
  },
  methods: {
    openVersionModal() {
      this.$modal.show("version-modal");
    },
  },
};
</script>
<style scoped>
.header-menu {
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  position: relative;
  z-index: 99;
}

.header-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 16px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo-section {
  flex-shrink: 0;
}

.logo-link {
  display: block;
  transition: transform 0.3s ease;
}

.logo-link:hover {
  transform: scale(1.05);
}

.logo-image {
  height: 50px;
  width: auto;
  display: block;
}

.user-section {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 16px;
}

.version-badge {
  font-size: 11px;
  font-weight: 600;
  color: #667eea;
  padding: 6px 12px;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
  border-radius: 8px;
  cursor: pointer;
  margin: 0;
  transition: all 0.3s ease;
  letter-spacing: 0.5px;
}

.version-badge:hover {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.2) 0%, rgba(118, 75, 162, 0.2) 100%);
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.2);
}

.user-link {
  text-decoration: none;
  color: inherit;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  border-radius: 12px;
  background: #f8f9fa;
  transition: all 0.3s ease;
}

.user-info:hover {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.user-text {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
}

.user-name {
  font-size: 15px;
  font-weight: 600;
  color: #2c3e50;
}

.user-settings {
  font-size: 10px;
  font-weight: 600;
  color: #667eea;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 18px;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.user-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  color: #667eea;
}

.blink {
  animation: blinker 1.5s ease-in-out infinite;
}

@keyframes blinker {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
}

/* RESPONSIVE */
@media (max-width: 768px) {
  .header-content {
    padding: 12px 16px;
  }
  
  .logo-image {
    height: 40px;
  }
  
  .version-badge {
    font-size: 10px;
    padding: 4px 8px;
  }
  
  .user-text {
    display: none;
  }
  
  .user-info {
    padding: 8px;
  }
  
  .user-avatar {
    width: 36px;
    height: 36px;
    font-size: 16px;
  }
}
</style>